import React from 'react';
import { Box, Button, FormControl, MenuItem, Select } from '@mui/material';
import enFlag from '../assets/en-flag.png';
import deFlag from '../assets/de-flag.png';
import frFlag from '../assets/fr-flag.png';
import { useTranslation } from 'react-i18next';

interface TopbarProps {
  isLoggedIn: boolean;
  onLoginOpen: () => void;
  onLogout: () => void;
  onContactOpen: () => void;
  language: string;
  changeLanguage: (lng: string) => void;
}

const Topbar: React.FC<TopbarProps> = ({
  isLoggedIn,
  onLoginOpen,
  onLogout,
  onContactOpen,
  language,
  changeLanguage,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'fixed', // fixé en haut de l'écran
        top: 0,
        left: 0,
        right: 0,
        height: 64,
        backgroundColor: '#282c34', // même fond que ta page
        display: 'flex',
        justifyContent: 'center', // centré horizontalement
        alignItems: 'center',
        zIndex: 1100, // pour rester au-dessus
        boxShadow: '0 2px 4px rgba(0,0,0,0.5)', // petite ombre discrète
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '1200px', // même largeur max que Profile / Resume
          display: 'flex',
          justifyContent: 'flex-end', // pousse les éléments à droite
          alignItems: 'center',
          gap: 2,
          px: 2,
        }}
      >
        {/* Language Selector */}
        <FormControl sx={{ minWidth: { xs: 60, sm: 100 } }}>
          <Select
            value={language}
            onChange={(e) => changeLanguage(e.target.value as string)}
            sx={{
              color: 'lightgray',
              '& .MuiSvgIcon-root': { color: 'white' },
              '& fieldset': { border: 'none' },
            }}
          >
            <MenuItem value="en">
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                <img src={enFlag} alt="English" style={{ width: 20, height: 20, marginRight: 6 }} />
              </Box>
            </MenuItem>
            <MenuItem value="de">
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <img src={deFlag} alt="Deutsch" style={{ width: 20, height: 20, marginRight: 6 }} />
              </Box>
            </MenuItem>
            <MenuItem value="fr">
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <img src={frFlag} alt="Français" style={{ width: 20, height: 20, marginRight: 6 }} />
              </Box>
            </MenuItem>
          </Select>
        </FormControl>

        {/* Resume Button */}
        <Button
          variant="outlined"
          onClick={onContactOpen}
          sx={{
            borderRadius: 20,
            borderColor: 'grey.600', 
            color: 'white',
            backgroundColor: 'transparent',
            '&:hover': {
              borderColor: '#26c6da',
              backgroundColor: '#1a1b1f',
            },
            textTransform: 'none',
            px: 3,
            py: 1,
            fontWeight: 'bold',
          }}
        >
          {t('resume')}
        </Button>

        {/* Login / Logout Button */}
        {!isLoggedIn ? (
          <Button
            variant="outlined"
            onClick={onLoginOpen}
            sx={{
              borderRadius: 20,
              borderColor: 'grey.600',
              color: 'white',
              backgroundColor: 'transparent',
              '&:hover': {
                borderColor: '#26c6da',
                backgroundColor: '#1a1b1f',
              },
              textTransform: 'none',
              px: 3,
              py: 1,
              fontWeight: 'bold',
            }}
          >
            {t('login')}
          </Button>
        ) : (
          <Button
          variant="outlined"
          onClick={onLogout}
          sx={{
            borderRadius: 20,
            borderColor: '#26c6da',
            color: '#26c6da',
            backgroundColor: '#1a1b1f',
            '&:hover': {
              borderColor: '#26c6da',
              backgroundColor: '#1a1b1f',
            },
            textTransform: 'none',
            px: 3,
            py: 1,
            fontWeight: 'bold',
          }}
        >
          {t('logout')}
        </Button>
          
        )}
      </Box>
    </Box>
  );
};

export default Topbar;
